import * as React from "react";
import { Landing } from "./pages/Landing";

export const App = () => <Landing />
